import { useCallback, useState } from "react";

/**
 * Generic hook that wraps an async service call with loading + error state.
 * Eliminates the repeated useState(loading)/useState(error) pattern in every component.
 *
 * Usage:
 *   const { execute, loading, error } = useApiCall();
 *   const data = await execute(() => myService.fetchSomething());
 */
export function useApiCall() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const execute = useCallback(async (fn) => {
    setLoading(true);
    setError("");
    try {
      return await fn();
    } catch (e) {
      const msg = e?.message || "An unexpected error occurred.";
      setError(msg);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => setError(""), []);

  return { execute, loading, error, clearError };
}
